import { render, staticRenderFns } from "./roleManagement.vue?vue&type=template&id=fa10e414&scoped=true"
import script from "./roleManagement.vue?vue&type=script&lang=js"
export * from "./roleManagement.vue?vue&type=script&lang=js"
import style0 from "./roleManagement.vue?vue&type=style&index=0&id=fa10e414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa10e414",
  null
  
)

export default component.exports